const GRADE_STYLE = {
  Excellent: "border-emerald-500 text-emerald-700 bg-emerald-50",
  "On Track": "border-blue-500 text-blue-700 bg-blue-50",
  Watch: "border-amber-500 text-amber-700 bg-amber-50",
  "At Risk": "border-rose-500 text-rose-700 bg-rose-50",
};

// Cost Health Score badge (0-100 + grade). `health` = { score, grade }.
export function HealthBadge({ health, testId, showGrade = true, className = "" }) {
  if (!health || typeof health.score !== "number") return null;
  const style = GRADE_STYLE[health.grade] || "border-border text-muted-foreground";
  return (
    <span data-testid={testId} title={`Cost Health ${health.score}/100 — ${health.grade}`}
      className={`inline-flex items-center gap-1.5 text-xs px-2 py-0.5 border ${style} ${className}`}>
      <span className="font-mono-fig font-semibold">{health.score}</span>
      {showGrade && <span>{health.grade}</span>}
    </span>
  );
}
